import React, { useEffect, useState } from 'react';
import Page from '../components/Page';
import { IconWidget } from '../components/Widget';
import {
    MdBubbleChart,
    MdInsertChart,
    MdPersonPin,
    MdPieChart,
    MdRateReview,
    MdShare,
    MdShowChart,
    MdThumbUp,
} from 'react-icons/md';
import {
    Col,
    Row,
} from 'reactstrap';
// api
import { getDashboard } from '../api/admin';



const Dashboard = () => {

    const [countDoc, setCountDoc] = useState({
        author: 0,
        totalBlogs: 0,
        activeBlogs: 0,
        inActiveBlogs: 0
    })

    const getData = async () => {
        try {
            const { status, result } = await getDashboard();
            if (status == true) setCountDoc(result)
        } catch (error) { }
    }
    useEffect(() => {
        getData()
        window.scrollTo(0, 0);
    }, [])

    return (
        <Page
            className="DashboardPage"
            title="Dashboard"
            breadcrumbs={[{ name: 'Dashboard', active: true }]}
        >
            <Row>
                <Col lg={3} md={6} sm={6} xs={12}>
                    <IconWidget
                        bgColor="secondary"
                        inverse={true}
                        icon={MdPersonPin}
                        title="Total Authors"
                        subtitle={countDoc?.author}
                    />
                </Col>

                <Col lg={3} md={6} sm={6} xs={12}>
                    <IconWidget
                        bgColor="danger"
                        inverse={true}
                        icon={MdPieChart}
                        title="Total Blogs"
                       subtitle={countDoc?.totalBlogs}
                    />
                </Col>

                <Col lg={3} md={6} sm={6} xs={12}>
                    <IconWidget
                        bgColor="info"
                        inverse={true}
                        icon={MdRateReview}
                        title="Active Blogs"
                       subtitle={countDoc?.activeBlogs}
                    />
                </Col>

                <Col lg={3} md={6} sm={6} xs={12}>
                    <IconWidget
                        bgColor="primary"
                        inverse={true}
                        icon={MdShowChart}
                        title="Inactive Blogs"
                       subtitle={countDoc?.inActiveBlogs}
                    />
                </Col>
            </Row>
        </Page>
    );
}

export default Dashboard;